import {
	getUserFromCookie,
	// getUserFromSession
} from '@/helpers';

export const actions = {

	async nuxtServerInit ({ dispatch }, { req }) {
		// console.log('[NUXT SERVER INIT] user', req);
		const user = getUserFromCookie(req);
		// const user = getUserFromSession(req);
		// const user = undefined;
		if (user) {
			await dispatch('user/refreshUser', { name: user.name, email: user.email, avatar: user.picture, uid: user.user_id, user: user});
		}
	}
};
